import React from "react";
import { Translate } from "orion-components/i18n";

const deviceStatusChangeBuilder = (rule, collections, shapes) => {
	// Determine feed names if subjects are specified
	let feedDisplay = null;
	let isMultiple = false;
	if (rule.subject && rule.subject.length > 0) {
		const feedNames = rule.subject.filter(s => s && (s.name || s.feedId)).map(s => s.name || s.feedId);
		if (feedNames.length > 0) {
			feedDisplay = feedNames.join(", ");
			isMultiple = feedNames.length > 1;
		}
	}

	// Determine status type from targets
	let statusType = "any";
	if (rule.targets && rule.targets.length > 0 && rule.targets[0]) {
		statusType = rule.targets[0].statusType || "any";
	}

	return (
		<div id="rule-statement" className="cb-font-b9">
			<Translate value="global.ruleBuilder.deviceStatusChange.alarmMe" />
			{feedDisplay ? (
				<Translate
					value={
						isMultiple
							? "global.ruleBuilder.deviceStatusChange.fromFeeds"
							: "global.ruleBuilder.deviceStatusChange.fromFeed"
					}
					count={feedDisplay}
				/>
			) : (
				<Translate value="global.ruleBuilder.deviceStatusChange.anyDevice" />
			)}
			{statusType === "online" && (
				<Translate
					value={
						isMultiple
							? "global.ruleBuilder.deviceStatusChange.goOnline"
							: "global.ruleBuilder.deviceStatusChange.goesOnline"
					}
				/>
			)}
			{statusType === "offline" && (
				<Translate
					value={
						isMultiple
							? "global.ruleBuilder.deviceStatusChange.goOffline"
							: "global.ruleBuilder.deviceStatusChange.goesOffline"
					}
				/>
			)}
			{statusType === "any" && (
				<Translate
					value={
						isMultiple
							? "global.ruleBuilder.deviceStatusChange.changeStatus"
							: "global.ruleBuilder.deviceStatusChange.changesStatus"
					}
				/>
			)}
		</div>
	);
};

export default deviceStatusChangeBuilder;
